import { render, staticRenderFns } from "./DashboardLayoutMyaffilAdmin.vue?vue&type=template&id=47698fa4&"
import script from "./DashboardLayoutMyaffilAdmin.vue?vue&type=script&lang=js&"
export * from "./DashboardLayoutMyaffilAdmin.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLayoutMyaffilAdmin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports